import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=0b5b0128&scoped=true&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"
import style0 from "./Page.vue?vue&type=style&index=0&id=0b5b0128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5b0128",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b5b0128')) {
      api.createRecord('0b5b0128', component.options)
    } else {
      api.reload('0b5b0128', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=0b5b0128&scoped=true&", function () {
      api.rerender('0b5b0128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/Page.vue"
export default component.exports